/*
 * @Author: Alan
 * @Date: 2023-06-05 16:37:43
 * @LastEditors: Alan
 * @LastEditTime: 2023-06-05 17:22:17
 * @Description: 游戏页面顶部banner图
 * @FilePath: \F1-M2-WEB-Code\components\Games\Page\Banner.js
 */
import React from "react";
import { setSupportFormats, getSupportFormats } from "$ACTIONS/imageHandler";
import { get } from "$ACTIONS/TlcRequest";
import { isGuest } from "../../actions/helper";
import { ApiPort } from "../../actions/TLCAPI";
import Header from "../Banner";

const lobbyBannerKeyMapping = {
    "ESports": "ESports",
    "Sportsbook": "Sportsbook",
    "Slot": "Slot",
    "LiveCasino": "LiveCasino",
    "Instant Games": "InstantGames",
    "P2P": "P2P",
    "Keno": "KenoLottery",
}

export class Gamesmaintop extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            supportFormats: getSupportFormats(), // 初始化時立即獲取當前支援格式（可能是回退值）
            topBanners: [],
        };
    }

    async componentDidMount() {
        // 確保支援格式初始化完成
        await setSupportFormats();
        // 更新狀態為最新的支援格式
        this.setState({ supportFormats: getSupportFormats() });
        await this.fetchBanners();
    }

    concatSplitWords(text) {
        // Check if text has multiple words separated by spaces
        if (/\s/.test(text)) {
            // Remove all spaces
            return text.replace(/\s+/g, '');
        }
        return text; // return original if no space found
    }
    
    piwikTrackEvent = (title, index) => {
        Pushgtagdata(
            `${this.props?.Routertype}_Listing`,
            "Click Banner",
            `${this.props?.Routertype}_Listing_C_Banner`,
            "",
            [
                {customVariableKey: `${this.props?.Routertype}_Listing_C_Banner_Title`,
                customVariableValue: title},
                {customVariableKey: `${this.props?.Routertype}_Listing_C_Banner_Position`,
                customVariableValue: index},
            ]         
        );
    }

    fetchBanners = async () => {
        try {
            const res = await get(
                ApiPort?.CmsProductLobbyBanner +
                    (isGuest() ? "before" : "after")
            );

            if (!Array.isArray(res) || res.length === 0) {
                console.warn("No banners found.");
                return;
            }
            
            const filteredRes = res.filter(
                (item) => (lobbyBannerKeyMapping[item.gameLobbyCategory] || item.gameLobbyCategory) === this.props.Routertype
            );
            
            this.setState({ topBanners: filteredRes });
        } catch (error) {
            console.error("Error fetching banners:", error);
        }
    };

    // 返回合適的圖片副檔名
    getExtension = () => {
        const { avif, webp } = this.state.supportFormats || {};

        return avif ? "avif" : webp ? "webp" : "jpg";
    };

    render() {
        const { Routertype } = this.props;

        // 根據當前支援格式生成副檔名
        const extension = this.getExtension();
        const imageUrl = `/th/img/home/banner/${Routertype}.${extension}`;

        return (
        <>
        { this.state.topBanners.length > 0 ?
            <div className="top-banner-Wrapper" key={Routertype}>
                <Header piwikTrackEvent={this.piwikTrackEvent} bannerList={this.state.topBanners}  bannertype={this.props?.Routertype} className="ProductLobbySlider" customizedWidth={1120} customizedHeight={185}/>
            </div>
            :
            <div className="top-banner"
            style={{
                background: `linear-gradient(#00a6ffb0 0%, #00A6FF 100%) 0% 0% no-repeat padding-box padding-box transparent`,
            }}
            >
                    <img
                    src={imageUrl}
                    style={{ width: "100%", height: "200px", objectFit: "cover" }}
                    alt={Routertype + " bannerimage"}
                />
            </div>
        }
        </>
        );
    }
}

export default Gamesmaintop;
